import { IonContent, IonPage } from "@ionic/react";
import type { ReactNode } from "react";

import { ActionBar } from "../../components/ActionBar";
import { Screen } from "../../components/Shell";
import { TopBar } from "../../components/TopBar";
import "../You.css";

/**
 * The frame every settings screen shares: a TopBar back to You, one line on what the screen is
 * for, the fields — and, when the screen has anything to save, Save docked at the bottom.
 *
 * Docked rather than placed after the last field because the profile's single save button used to
 * sit two thirds of the way down a 1,000-line page, where it was neither findable nor obviously
 * connected to the fields above it. Low and fixed also puts it under the thumb. (ADR-018) Disabled
 * until something changes, and it says so in words — a grey button with no reason reads as broken.
 */
export default function SettingsPage({
  title,
  intro,
  children,
  onSave,
  dirty,
  saveLabel = "Save",
}: {
  title: string;
  /** one line on what this screen is for, when that is not obvious from the title */
  intro?: ReactNode;
  children: ReactNode;
  onSave?: () => void;
  dirty?: boolean;
  saveLabel?: string;
}) {
  return (
    <IonPage>
      <IonContent>
        <Screen>
          <TopBar title={title} back={{ to: "/you", label: "Back to You" }} />
          <div className="you-page">
            {intro ? <p className="you-intro">{intro}</p> : null}
            {children}
          </div>
          {onSave ? (
            <ActionBar
              primary={{
                label: saveLabel,
                onClick: onSave,
                disabled: !dirty,
                reason: "No changes yet",
              }}
            />
          ) : null}
        </Screen>
      </IonContent>
    </IonPage>
  );
}
